import React, { useContext, useEffect, useRef, useState } from "react";
import Header3 from "../components/Header3";
import Footer2 from "../components/Footer2";
import { useNavigate } from "react-router-dom";
import { Form, Modal } from "react-bootstrap";
import { useAuth } from "../context/auth";
import axios from "../AxiosInstance";
import { BASE_URL } from "../config/BaseUrls";
import { LanguageContext } from "../context/LanguageContext";

const countries = [
  "Australia",
  "Canada",
  // "United Kingdom",

  "France",
  "Germany",

  "United States",
  "Brazil",
  "Mexico",

  // Add other countries as needed
];

const LoyalityProgramme = () => {
  const { lg } = useContext(LanguageContext);

  const [selectedImageLaed, setSelectedImageLaed] = useState(null);
  const fileInputRefLaed = useRef(null);

  // Load the selected image from localStorage on component mount
  useEffect(() => {
    const storedImageLaed = localStorage.getItem("loyaltyProfileImage");
    if (storedImageLaed) {
      setSelectedImageLaed(storedImageLaed);
    }
  }, []);

  const handleButtonClickLaed = () => {
    if (fileInputRefLaed.current) {
      fileInputRefLaed.current.click();
    }
  };

  const handleFileChangeLaed = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImageLaed(reader.result); // Set the selected image as a base64 URL
        localStorage.setItem("loyaltyProfileImage", reader.result); // Save to localStorage
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    }
  };

  const navigate = useNavigate();
  const [show, setShow] = useState(false); // For signup modal

  // Handle closing both modals
  const handleClose = () => {
    setShow(false); // Close signup modal
  };

  // Handle opening signup modal
  const handleShow = () => {
    setShow(true); // Open signup modal
  };

  const handleCountrySelect = (event) => {
    const selectedCountry = event.target.value;
    if (selectedCountry) {
      navigate(`/groupeventcreation`); // Replace with your actual route
    }
  };

  // FAtch User Details
  const [auth, setAuth] = useAuth();

  const userId = auth?.user?._id;

  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      if (!userId) return; // Don't make API call if userId is undefined
      try {
        const res = await axios.get(`api/v1/auth/user-profile/${userId}`);
        setUser(res.data.data);
      } catch (err) {
        console.error("Error:", err);
      }
    };

    fetchUser();
  }, [userId]);

  return (
    <>
      <div className="loyslrsding">
        <Header3 />
      </div>
      <div className="alincenterawidth">
        <div
          className="highyauto"
          style={{
            backgroundColor: "#F2F2F2",
            height: "185px",
            alignItems: "center",
          }}
        >
          <div
            className="d-md-flex  justzomag11   mlmrleading gap-xl-5 gap-4 "
            style={{ paddingTop: "30px" }}
          >
            <div className="textsmctrlead   ">
              {/* Header */}
              <div className="d-sm-flex  gap-2 gap-md-3 ">
                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRefLaed}
                  style={{ display: "none" }} // Hide the input
                  onChange={handleFileChangeLaed} // Handle file change
                />
                <img
                  src={
                    user?.profileImage
                      ? BASE_URL + "/uploads/" + user.profileImage
                      : require("../pages/image/addphotoicon.png")
                  } // Show user-selected image or default image
                  alt="Profile"
                  className="rounded-circle widimg "
                  width="105px"
                  height="105px"
                  style={{ width: "105px", height: "105px" }}
                  //   style={{ width: "118px", height: "118px" }} // Set dimensions as needed
                  // onClick={handleButtonClickLaed} // Allow clicking on the image to upload a new one
                />
                <div className="text-center text-sm-start">
                  <div
                    className=" mt-2 fw-bold fs-22 ftzpual text-dark "
                    style={{ lineHeight: "33.6px" }}
                  >
                    {user?.name}
                  </div>
                  <div
                    className="fw-normal ftzpual fs-22"
                    style={{ color: "#DF8244" }}
                  >
                    Ambassador
                  </div>
                  <div
                    className="fw600 fs-18 ftzpual  ftzgern"
                    style={{ color: "#2A2A2A" }}
                  >
                    {/* Level */}
                    {lg?.level}1
                  </div>
                </div>
              </div>
            </div>

            <div className=" mt-xl-4 mt-md-0 mt-2 pt-2 mx-lg-5 mlmreditbrns justify-content-center  d-flex flex-wrap gap-4">
              <button
                className="text-white rounded-1 fw-bold fs-18 btnedit2 ftzgern border-0 text-center"
                style={{
                  width: "153px",
                  height: "53px",
                  backgroundColor: "#34C3C9",
                }}
                onClick={() => navigate("/profile")}
              >
                {/* EDIT PROFILE */}
                {/* Edit Profile */}
                {lg?.editprf}
              </button>

              <button
                className="text-white  rounded-1 fw-bold btneditmeet ftzgern border-0 text-center"
                style={{
                  width: "180px",
                  height: "53px",
                  backgroundColor: "#34C3C9",
                  fontSize: "18px",
                  lineHeight: "18px",
                }}
                // onClick={handleShow} // Trigger modal on click
                onClick={() => navigate("/booksdetails")}
              >
                {/* CREATE <br /> BOOK CLUB */}
                {/* Create <br /> Book Club */}
                {lg?.cbclub}
              </button>
              <button
                className="text-white  rounded-1 fw-bold btneditmeet ftzgern border-0 text-center"
                style={{
                  width: "180px",
                  height: "53px",
                  backgroundColor: "#34C3C9",
                  fontSize: "18px",
                  lineHeight: "18px",
                }}
                onClick={() => navigate("./silentreading")} // Trigger modal on click
              >
                {/* CREATE <br /> SILENT READING */}
                {/* Create <br /> Silent Reading */}
                {lg?.cbsil}
              </button>
              {/* <button
                     className="text-white rounded-1 fw-bold btneditmeet ftzgern  border-0 text-center"
                     style={{
                       width: "187px",
                       height: "53px",
                       backgroundColor: "#34C3C9",
                       fontSize: "18px",
                       lineHeight: "18px",
                     }}
                   >
                     Create 1:1
                     <br /> Meetup
                   </button> */}

              <button
                className="text-white rounded-1 fw-bold btneditmeet ftzgern  border-0 text-center"
                style={{
                  width: "180px",
                  height: "53px",
                  backgroundColor: "#34C3C9",
                  fontSize: "18px",
                  lineHeight: "18px",
                }}
                onClick={() => navigate("/createmeetup")}
              >
                {/* CREATE
                     <br /> BOOK DUO{" "} */}
                {/* Create
                <br /> Book Duo */}
                {lg?.cbduo}
              </button>

              <Modal
                show={show}
                onHide={handleClose}
                centered
                className="custom-modalmeet"
              >
                <Modal.Header className=" border-0">
                  <img
                    className=" border-0 closebtn mt-4 top-0 "
                    src={require("../components/image/close.png")}
                    alt="logo"
                    onClick={handleClose}
                  />
                </Modal.Header>
                <Modal.Title
                  className="text-center text-dark fw-bold mt-3 modeltitlemeet"
                  style={{
                    fontSize: "42px",
                    lineHeight: "43.58px",
                  }}
                >
                  Welcome!
                </Modal.Title>
                <Modal.Body className="mx-auto">
                  <div
                    className="fs-5 fw600  text-center w-100 ftzcopy mt-5  "
                    style={{ maxWidth: "600px" }}
                  >
                    You are going to explore the list of books available for a
                    Book Club.
                  </div>
                  <div className="fs-4 fw-bold mt-4 text-center">
                    Let’s start!
                  </div>

                  <div
                    className="mx-auto  mt-4"
                    style={{
                      width: "100px",
                      height: "40px",
                      backgroundColor: "#E9E9E9",
                      borderRadius: "10px",
                      color: "#3B3B3B",
                    }}
                  >
                    <Form.Select
                      aria-label="Select Country"
                      className="outline11 custom-select   fw600 fs-5  py-1   coumtrywid ftzcopy "
                      style={{
                        backgroundColor: "#62C0C7",
                        width: "160px",
                        // height: "44px",
                        lineHeight: "40px",
                        color: "#fff",
                        paddingLeft: "30px",
                        cursor: "pointer",
                      }}
                      onChange={handleCountrySelect} // Handle the change event
                    >
                      <option value="">Country</option>
                      {countries.map((country, index) => (
                        <option key={index} value={country}>
                          {country}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>

        <div
          className="d-flex justzomag11 leadflex leadflexloy gap-lg-5 gap-1  w-100  text-uppercase"
          style={{ backgroundColor: "#A6A6A6", height: "59px" }}
        >
          <div
            className="px-lg-5 px-md-4 px-3 pt-3    ftzgern text-dark fw-bold fs-18 text-center  "
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/leading")}
          >
            I’m leading
          </div>

          <div
            className="px-md-3 px-2 pt-3 ftzgern text-dark fw-bold fs-18 text-center"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/dashboarduser")}
          >
            {/* I’M JOINING */}
            {lg?.joining}
          </div>

          <div
            className="px-md-3 px-2 py-3  ftzgern text-dark fw-bold fs-18 text-center"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/booksandreviewsuser")}
          >
            {/* Books & reviews */}
            {lg?.bandrew}
          </div>
          {/* px-md-5 px-md-4 px-3 py-sm-2 pt-2 pb-3 */}
          <div
            className="px-md-4 px-sm-2 py-3  bg-white ftzgern text-dark fw-bold fs-18 text-center "
            style={{ lineHeight: "25px", cursor: "pointer" }}
            onClick={() => navigate("/loyalty")}
          >
            {/* Loyalty programme */}
            {lg?.loyprog}
          </div>
        </div>

        <div className="d-sm-flex justzomag11 text-center text-sm-start  mt-5 pt-sm-3 mlmrjustgift align-items-center ">
          <div className="">
            <img src={require("./image/giftbox.png")} />
          </div>

          <div className="mt-3 mt-sm-0">
            <div
              className="fw-bold giftftz ftzwork"
              style={{ fontSize: "37px" }}
            >
              Gifts and discounts on reading
            </div>
            <div className="fs-5 fw600 ftzgern" style={{ color: "#313131" }}>
              The more you read, the more you win! Enjoy discount
            </div>
          </div>
        </div>

        <div className="d-flex my-5 pt-md-5 gap-xl-3 gap-4 flex-wrap mx-auto justify-content-center">
          <div
            className="w-100  rounded-5 p-4 px-5 text-center fw-normal "
            style={{
              maxWidth: "311px",
              height: "165px",
              border: "0.76px solid #34C3C9",
              backgroundColor: "#F1F1F1",
              fontSize: "13.68px",
            }}
          >
            <div
              className="text-white zind w-100 rounded-3 text-center mx-auto fw600"
              style={{
                fontSize: "15px",
                backgroundColor: "#34C3C9",
                maxWidth: "90px",
                height: "23px",
              }}
            >
              Level 1
            </div>
            <div className="w-100 py-3" style={{ maxWidth: "265px" }}>
              To unlock Level 1 you need to lead at least 5 group events and
              leave 25 reviews.
            </div>
            <div className="w-100 " style={{ maxWidth: "265px" }}>
              Award: You will receive Ofellio Kit Ambassador for free!
            </div>
          </div>

          <div
            className="w-100  rounded-5 p-4 px-4 text-center fw-normal "
            style={{
              maxWidth: "311px",
              height: "165px",
              border: "0.76px solid #34C3C9",
              backgroundColor: "#F1F1F1",
              fontSize: "13.68px",
            }}
          >
            <div
              className="text-white zind w-100 rounded-3 text-center mx-auto fw600"
              style={{
                fontSize: "15px",
                backgroundColor: "#34C3C9",
                maxWidth: "90px",
                height: "23px",
              }}
            >
              Level 2
            </div>
            <div className="w-100 py-3" style={{ maxWidth: "265px" }}>
              To unlock Level 2 you have led 20 group events and leave 30 new
              reviews.
            </div>
            <div className="w-100 " style={{ maxWidth: "265px" }}>
              Award:
            </div>
          </div>

          <div
            className="w-100  rounded-5 p-4 px-4 text-center fw-normal "
            style={{
              maxWidth: "311px",
              height: "165px",
              border: "0.76px solid #34C3C9",
              backgroundColor: "#F1F1F1",
              fontSize: "13.68px",
            }}
          >
            <div
              className="text-white zind w-100 rounded-3 text-center mx-auto fw600"
              style={{
                fontSize: "15px",
                backgroundColor: "#34C3C9",
                maxWidth: "90px",
                height: "23px",
              }}
            >
              Level 3
            </div>
            <div className="w-100 py-3" style={{ maxWidth: "265px" }}>
              To unlock Level 3 you have led 35 group events and leave 50 new
              reviews.
            </div>
            <div className="w-100 " style={{ maxWidth: "265px" }}>
              Award:
            </div>
          </div>

          <div
            className="w-100  rounded-5 p-4 px-4 text-center fw-normal "
            style={{
              maxWidth: "311px",
              height: "165px",
              border: "0.76px solid #34C3C9",
              backgroundColor: "#F1F1F1",
              fontSize: "13.68px",
            }}
          >
            <div
              className="text-white zind w-100 rounded-3 text-center mx-auto fw600"
              style={{
                fontSize: "15px",
                backgroundColor: "#34C3C9",
                maxWidth: "90px",
                height: "23px",
              }}
            >
              Level 4
            </div>

            {/* <div className="w-100 py-3" style={{ maxWidth: "265px" }}>
            To unlock Level 3 you have led 35 group events and leave 50 new
            reviews.
          </div>
          <div className="w-100 " style={{ maxWidth: "265px" }}>
            Award:
          </div> */}
          </div>
        </div>
      </div>

      <div className="mt-5">
        <Footer2 />
      </div>
    </>
  );
};

export default LoyalityProgramme;
